import React from "react";
import MyPageBanner from "../components/MyPageBanner";
import NewsFeed from "../components/NewsFeed";

const FlyersPage = ({ bannerImage }) => {
  return (
    <>
      <MyPageBanner
        imageUrl={bannerImage}
        text="Noticias"
        subtitle="Avisos, registros y volantes de la liga."
      />
      <NewsFeed showFlyers />
    </>
  );
};

export default FlyersPage;
